import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BackButton from "../../components/BackButton";
import TitleRecordFunction from "../../components/TitleRecordFunction";
import api from '../../api/manage_database/ConverterReq';
import { useLocation } from "react-router-dom";
import { toast } from 'sonner';
import { FaSave } from "react-icons/fa";
import Spinner from "../../components/Spinner";
import SelectConverterType from "../../components/SelectConverterType";
import InputTrackAmount from "../../components/InputTrackAmount";

const ConverterRecord = () => {
    
    const location = useLocation();

    const addRecordMessage = location.state?.addRecordMessage;
    const deleteRecordMessage = location.state?.deleteRecordMessage;
    
    const isViewRecord = location.state?.anotherTypeOfPage === undefined;

    const { converter_id } = useParams();
    
    const deletedConverter = location.state?.data

    const [editState, setEditState] = useState(false);
    
    const [converterTypes, setConverterTypes] = useState([]);
    const [type, setType] = useState('');
    const [selectedConverterType, setSelectedConverterType] = useState('');
    const [trackAmount, setTrackAmount] = useState();

    const [updatingRecordState, setUpdatingRecordState] = useState(false);
    
    const handleEditButton = () => {
        setEditState(prev => !prev);
    }

    const handleSaveButton = async () => {
        setUpdatingRecordState(true);
        const toastId = toast('');
        toast.loading('Updating Converter record...', {id: toastId});
        try {
            const response = await api.put(
                '/record',
                {
                    id: converter_id,
                    type: selectedConverterType,
                    track_amount: trackAmount
                },
                {
                    withCredentials: true
                }
            );
            if (response.data.success) {
                toast.success(response.data.message, {id: toastId});
                setType(response.data.payload[0].type);
                setSelectedConverterType(response.data.payload[0].type);
                setTrackAmount(response.data.payload[0].track_amount);
            } else {
                toast.error(response.data.message, {id: toastId});
            }
        } catch (err) {
            console.log(err.response);
        }
        setEditState(prev => !prev);
        setUpdatingRecordState(false);
    }

    const handleInputTrackAmount = (e) => {
        if (e.target.value > 4) {
            setTrackAmount(4);    
        } else if (e.target.value < 1) {
            setTrackAmount(1);
        } else {
            setTrackAmount(e.target.value);
        }        
    }

    useEffect(() => {
        const fetchConverterTypes = async () => {
            try {
                const response = await api.get('types', {withCredentials: true});
                if (response.data.success) {
                    setConverterTypes(response.data.payload.types);
                } else {
                    toast.error('Not got data from database');
                }
            } catch (err) {
                console.log(err.response);
            }
        };

        fetchConverterTypes();
    }, []);

    useEffect(() => {
        const getConverterDescriptionData = async() => {
            let attempts = 0
            while (attempts < 5) {
                try {
                    const response = await api.get(`record/${converter_id}`, {withCredentials: true});
                    if (response.data.success) {
                        setType(response.data.payload[0].type);
                        setSelectedConverterType(response.data.payload[0].type);
                        setTrackAmount(response.data.payload[0].track_amount);
                        return
                    } else {
                        toast.warning('Not got data from database! trying again...');
                    }
                    
                } catch (err) {
                    console.log(err.response);
                }
                
                attempts++;
                if (attempts < 5) {
                    await new Promise((res) => setTimeout(res, 2000));
                }
            }

            toast.error(`Data is not received after ${attempts} requests!`);
        };
        if (deletedConverter === undefined) {
            getConverterDescriptionData();
        } else {
            setType(deletedConverter.type);
            setSelectedConverterType(deletedConverter.type);
            setTrackAmount(deletedConverter.track_amount);
        }
    }, []);
    
    return (
        <div className='converter-record-container'>
            <div className="converter-record-title-wrapper">
                <TitleRecordFunction
                    addRecordMessage={addRecordMessage}
                    deleteRecordMessage={deleteRecordMessage}
                    title='Converter'
                    isViewRecord={isViewRecord}
                />
                {deletedConverter === undefined ? 
                    !editState ?
                        <button
                            className='converter-record-edit-button'
                            onClick={handleEditButton}
                        >   Edit
                        </button> :
                        <button
                            className='converter-record-save-button'
                            onClick={handleSaveButton}
                        >   Save &nbsp; <FaSave />
                        </button>
                : null}
            </div>
            {updatingRecordState ? <Spinner /> :
                <table className='converter-record-table-style'>
                    {
                    editState ? 
                        <tbody>
                            <tr>
                                <td>ID:</td>
                                <td>{converter_id}<br /></td>
                            </tr>
                            <tr>
                                <td>Type:</td>
                                <td>
                                    <SelectConverterType
                                        ConverterTypes={converterTypes}
                                        selectedConverterType={selectedConverterType}
                                        setSelectedConverterType={setSelectedConverterType}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>Track Amount:</td>
                                <td>
                                    <InputTrackAmount
                                        trackAmount={trackAmount}
                                        handleInputTrackAmount={handleInputTrackAmount}
                                    />
                                </td>
                            </tr>                 
                        </tbody> :
                        <tbody>
                            <tr>
                                <td>ID:</td>
                                <td>{converter_id}<br /></td>
                            </tr>
                            <tr>
                                <td>Type:</td>
                                <td>{type}<br /></td>
                            </tr>
                            <tr>
                                <td>Track Amount:</td>
                                <td>{trackAmount}<br /></td>
                            </tr>                            
                        </tbody>}    
                </table>}
            <BackButton
                navigateTo='/manage-database'
            />
        </div>
    )
}

export default ConverterRecord;